import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import mermaid from 'mermaid'
import styled, { useTheme } from 'styled-components'

const MermaidBlock = ({ chart }) => {
  const theme = useTheme()
  const mermaidRef = useRef(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    const element = mermaidRef.current
    if (!element) return undefined

    let cancelled = false
    setFailed(false)

    mermaid.initialize({
      startOnLoad: false,
      securityLevel: 'strict',
      suppressErrorRendering: true,
      theme: theme.id === 'dark' ? 'dark' : 'default',
      flowchart: { useMaxWidth: true, htmlLabels: true }
    })

    element.removeAttribute('data-processed')
    element.textContent = chart

    mermaid
      .run({ nodes: [element], suppressErrors: true })
      .then(() => {
        if (!cancelled && !element.querySelector('svg')) setFailed(true)
      })
      .catch(() => {
        if (!cancelled) setFailed(true)
      })

    return () => {
      cancelled = true
    }
  }, [chart, theme.id])

  if (failed) {
    return (
      <MermaidError>
        <code>{chart}</code>
      </MermaidError>
    )
  }

  return <MermaidChart ref={mermaidRef} className="mermaid" />
}

MermaidBlock.propTypes = {
  chart: PropTypes.string.isRequired
}

export default MermaidBlock

const MermaidChart = styled.div`
  margin: 20px 0;
  width: 100%;
  text-align: center;

  svg {
    display: block;
    max-width: 100%;
    height: auto !important;
    margin: 0 auto;
  }
`

const MermaidError = styled.pre`
  white-space: pre-wrap;
`
